import { IconCheckOutline18 as Check } from "nucleo-ui-outline-18"

import { cn } from "@productlane/lib/src/cn"
import { CommandItem } from "@productlane/ui/src/components/internal/command"

import type { SharedFilterItemsProps } from "@/components/filters"
import { useCompanyAttributeValues } from "@/lib/use-company-attribute-values"
import { useCompaniesFilterState } from "../companies-filter-state"

export function StatusFilterItems({ onSelect }: SharedFilterItemsProps) {
	const { statuses, addStatus, removeStatus } = useCompaniesFilterState()

	const { statuses: availableStatuses } = useCompanyAttributeValues()

	if (availableStatuses.length === 0) {
		return (
			<div className="py-4 text-center text-sm text-secondary">
				No statuses found
			</div>
		)
	}

	return (
		<>
			{availableStatuses.map((status) => {
				const isSelected = statuses.includes(status.name)
				return (
					<CommandItem
						key={status.name}
						onSelect={() => {
							if (isSelected) {
								removeStatus(status.name)
							} else {
								addStatus(status.name)
							}
							onSelect()
						}}
					>
						<div className="flex w-full items-center gap-2">
							<div
								className="h-2 w-2 shrink-0 rounded-full"
								style={{ backgroundColor: status.color }}
							/>
							<span className="flex-1 truncate">{status.name}</span>
							<Check
								className={cn("h-4 w-4 shrink-0", {
									"opacity-100": isSelected,
									"opacity-0": !isSelected,
								})}
							/>
						</div>
					</CommandItem>
				)
			})}
		</>
	)
}
